import React from 'react';
import PropTypes from 'prop-types';

import { Box } from "~/native-ui/native-base";

const CardText = ({ children, className, theme, ...other }) => (
  <Box {...other}>
    {children}
    {/* {typeof children === 'string' ? <Text>{children}</Text> : children} */}
  </Box>
);

CardText.propTypes = {
  children: PropTypes.node,
};

export default CardText;
export { CardText };
